import Vue from 'vue';
import VueRouter from 'vue-router';
import LayoutMenuTopoConteudo from '../views/layouts/LayoutMenuTopoConteudo.vue';
import LayoutTopoConteudo from '../views/layouts/LayoutTopoConteudo.vue';
import LayoutVazio from '../views/layouts/LayoutVazio.vue';
import _404 from '../views/404.vue';
import store from '../store/index'
import storage from '../store/modules/storage'
import * as previaStudio from '../services/previaStudio';
import axios from 'axios';
import lodash from 'lodash';

var LAYOUTS = {
  LayoutMenuTopoConteudo,
  LayoutTopoConteudo,
  LayoutVazio
}

Vue.use(VueRouter);

var router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [],
});

var rotasEssenciais = [];

router.beforeEach(async (to, from, next) => {
  atualizaHistoricoRotas(to, from)
  next();
})

function atualizaHistoricoRotas(to, from) {
  if (to.path != from.path) {

    let rotaExistente = undefined

    if (Vue.prototype.$routeHistory) {
      rotaExistente = Vue.prototype.$routeHistory.find((rota) => rota.path == to.path)
    }

    Vue.prototype.$routeHistory = []

    if (to.path == "/home") {
      //Se a rota for home inicia com valores vazios
      Vue.prototype.$routeHistory.push({
        text: "",
        to: ""
      })
    } else {
      Vue.prototype.$routeHistory.push({
        text: "Home",
        to: "/home"
      })

      if (from.path !== "/" && from.path !== "/home" && !rotaExistente) {
        Vue.prototype.$routeHistory.push({
          text: from.name,
          to: from.path
        })
      }

      Vue.prototype.$routeHistory.push({
        text: to.name,
        to: to.path
      })
    }
  }
}


export const somenteAutenticado = (to, from, next) => {

  if (window && window.ReactNativeWebView) {
    const postMessage = {
      type : "routerAction",
      params : { 
        path : to?.path
      }
    };
    window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessage));
  };

  const token = storage.getToken();

  if (token) {
    next();
  } else {
    const rota = rotasEssenciais.filter(item => item.meta.isLogin);
    if (rota.length && rota[0].name) {
      next({
        name: rota[0].name
      });
    } else {
      next({
        name: 'rota-nao-definida'
      });
      console.error("[ROUTER] Falha ao registrar uma rota de login (nenhuma rota com 'isLogin' foi definida) ");
    }
  }
}

// Método utilizado no beforeEnter das rotas.
// Ele que decide se vai pode acessar ou não
export const somenteNaoAutenticado = (to, from, next) => {

  if (window && window.ReactNativeWebView) {
    const postMessage = {
      type : "routerAction",
      params : { 
        path : to?.path
      }
    };
    window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessage));
  };
  
  const token = storage.getToken();
  
  if (token) {
    const dados          = JSON.parse(window.localStorage.getItem('usuarioLogado'));
    const modoAplicacao  = dados?.modoAplicacao || null;
    const rota           = getHomeRouteForMode(modoAplicacao);

    if (rota && rota.name) {
      next({
        name: rota.name
      });
    } else {
      next({
        name: 'rota-nao-definida'
      });

      console.error("[ROUTER] Falha ao registrar uma rota home (nenhuma rota com 'isHome' foi definida) ");
    }
  } else {
    next();
  }

  registerModule(to)
}

function registrarRotaPadrao() {
  //Usado para redirecionar qualquer requisição não registradaz
  let rotaDefault = router.getRoutes().filter(item => item.meta.isLogin);
  if (rotaDefault.length && rotaDefault[0].name) {
    router.addRoute({
      path: '*',
      redirect: {
        name: rotaDefault[0].name
      },
    });
  } else {
    console.error("[ROUTER] / Default - Falha ao registrar uma rota de login (nenhuma rota com 'isLogin' foi definida) ");
  }
}

function registrarRota404() {
  router.addRoute({
    path: '/404',
    name: 'rota-nao-definida',
    meta: {
      id: 'nao-definido'
    },
    component: _404
  });
}



getRoutes()

function getRoutes() {
  if (process.env.VUE_APP_SUBDOMINIO) {
    Vue.prototype.$host = {
      hostname: window.location.host,
      protocolo: window.location.protocol,
      subdominio: process.env.VUE_APP_SUBDOMINIO
    }
  } else {
    Vue.prototype.$host = {
      hostname: window.location.host,
      protocolo: window.location.protocol,
      subdominio: window.location.host.split('.')[0]
    }
  }

  registrarRota404();

  function registraRotasEssenciais(dadosFront) {
    const rotas = dadosFront.estrutura.filter((rota) => rota.props.isLogin || rota.props.isHome);

    for (const rotaEssencial of rotas) {
      rotasEssenciais.push({
        name: rotaEssencial.id,
        meta: rotaEssencial.props
      })
    }
  }

  const subdominio = Vue.prototype.$host.subdominio
  previaStudio.iniciar(subdominio)
  storage.getFrontend(subdominio).then(dadosFront => {

    if (dadosFront && dadosFront.estrutura) {
      document.title = dadosFront.titulo || 'Sem título';
      registerModule({ name: 'mainFramework' });
      registerModule({ name: 'demo' });
      registerModule({ name: 'clicCodeStudio' });

      registraRotasEssenciais(dadosFront)

      dadosFront.estrutura.forEach(dadosRota => {
        let rota = {
          ...dadosRota,
          name: dadosRota.id,
          path: dadosRota.props.path,
          component: LAYOUTS[dadosRota.component],
          meta: {
            childrens: dadosRota.childrens,
            events: dadosRota.events,
            isLogin: dadosRota.props.isLogin,
            isHome: dadosRota.props.isHome,
            validHomeModes: dadosRota.props.validHomeModes,
            title: stringToObject(dadosRota.props.title),
            subtitle: stringToObject(dadosRota.props.subtitle)
          },
          beforeRouteEnter: dadosRota.props.authenticated ? somenteAutenticado : somenteNaoAutenticado,
          beforeEnter: dadosRota.props.authenticated ? somenteAutenticado : somenteNaoAutenticado,
        }
        delete rota.childrens;
        router.addRoute(rota);

      });

      registrarRotaPadrao();


      //Estrutura de menus
      if (dadosFront.menus) {
        Vue.prototype.$menus = dadosFront.menus;
      }

      //Estrutura do css
      if (dadosFront.css) {
        Vue.prototype.$css = dadosFront.css;
        aplicarCssDinamico(dadosFront.css);
      }

      //Estrutura navbar
      if (dadosFront.navbar) {
        Vue.prototype.$navbar = dadosFront.navbar;
      }

      // Estrutura scripts
      if (dadosFront.scripts) {
        Vue.prototype.$scripts = dadosFront.scripts;
      }

    } else if (dadosFront && dadosFront.css) {
      aplicarCssDinamico(dadosFront.css);
    }
  })
}

export function getHomeRouteForMode(modo) {
  const homeRoutes = rotasEssenciais.filter(r => r.meta.isHome);

  if(modo){
    const homeEspecifica = homeRoutes.find(r => 
      r.meta.validHomeModes && r.meta.validHomeModes.includes(modo)
    );
    
    if (homeEspecifica) { return homeEspecifica }
  }

  const homeGenerica = homeRoutes.find(r => 
    !r.meta.validHomeModes || r.meta.validHomeModes.length === 0
  );

  return homeGenerica;
  
}

function stringToObject(string) {
  try {
    return JSON.parse(string);
  } catch (_) {
    return string;
  }
};

function registerModule(to) {
  if (!store.hasModule(to.name)) {
    store.registerModule(`${to.name}`, {
      namespaced: true,
      state() {
        return {
          propriedades: {},
        }
      },
      getters: {
        getPropriedades(state) {
          return state.propriedades
        },
      },
      mutations: {
        setPropriedades(state, propriedades) {
          if (propriedades) {
            state.propriedades = { ...state.propriedades, ...propriedades };
          }

        },
      },
    })
  }
}

function aplicarCssDinamico(listaCss) {
  for (const objCss of listaCss) {
    let cssAplicacao = document.createElement('style');
    cssAplicacao.textContent = objCss.css;
    document.head.appendChild(cssAplicacao);
  }
}


export default router;
